<template>
  <div>
    <vx-card>
      <div class="flex justify-between items-center mb-4">
        <h2>HaioFlash Regions</h2>
        <vs-button color="primary" @click="showDialog = true">
          <feather-icon icon="PlusIcon" class="mr-2"></feather-icon>
          Add Region
        </vs-button>
      </div>
      
      <!-- Filters -->
      <vs-row class="mb-4">
        <vs-col vs-w="4" vs-sm="6" vs-xs="12">
          <vs-input
            v-model="filters.name"
            class="w-full"
            label-placeholder="Search by name"
            @keyup.enter="loadRegions()"
          ></vs-input>
        </vs-col>
        <vs-col vs-w="3" vs-sm="6" vs-xs="12">
          <vs-select
            v-model="filters.is_active"
            class="w-full"
            placeholder="Status"
            @change="loadRegions()"
          >
            <vs-select-item value="" text="All"></vs-select-item>
            <vs-select-item :value="1" text="Active"></vs-select-item>
            <vs-select-item :value="0" text="Inactive"></vs-select-item>
          </vs-select>
        </vs-col>
        <vs-col vs-w="2" vs-sm="12" vs-xs="12">
          <vs-button color="primary" class="w-full" @click="loadRegions()">
            <feather-icon icon="SearchIcon"></feather-icon>
          </vs-button>
        </vs-col>
      </vs-row>
      
      <!-- Regions Table -->
      <vs-table v-if="regions" :data="regions">
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Code</vs-th>
          <vs-th>Location</vs-th>
          <vs-th>Active Nodes</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Actions</vs-th>
        </template>
        
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.id }}</vs-td>
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td>{{ tr.country_code }}</vs-td>
            <vs-td>{{ tr.city }}</vs-td>
            <vs-td>{{ tr.active_nodes || 0 }} / {{ tr.total_nodes || 0 }} ({{ tr.total_vms || 0 }} VMs)</vs-td>
            <vs-td>
              <vs-chip :color="tr.is_active ? 'success' : 'danger'">
                {{ tr.is_active ? 'Active' : 'Inactive' }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="primary"
                type="border"
                icon="edit"
                @click="editRegion(tr)"
              ></vs-button>
              <vs-button
                size="small"
                :color="tr.is_active ? 'warning' : 'success'"
                type="border"
                icon="power_settings_new"
                @click="toggleRegionStatus(tr.id)"
              ></vs-button>
              <vs-button
                size="small"
                color="danger"
                type="border"
                icon="delete"
                @click="deleteRegion(tr.id)"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    
    <!-- Create/Edit Dialog -->
    <vs-popup
      title="Region Details"
      :active.sync="showDialog"
    >
      <div class="p-4">
        <vs-row>
          <vs-col vs-w="12">
            <vs-input
              v-model="formData.name"
              class="w-full mb-3"
              label="Region Name"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12">
            <vs-input
              v-model="formData.code"
              class="w-full mb-3"
              label="Region Code (e.g., us-east-1)"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12">
            <vs-input
              v-model="formData.country"
              class="w-full mb-3"
              label="Country"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12">
            <vs-input
              v-model="formData.city"
              class="w-full mb-3"
              label="City"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12">
            <vs-input
              v-model.number="formData.display_order"
              class="w-full mb-3"
              label="Display Order"
              type="number"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="12">
            <vs-textarea
              v-model="formData.description"
              class="w-full mb-3"
              label="Description"
            ></vs-textarea>
          </vs-col>
          
          <vs-col vs-w="12">
            <h4 class="mb-2">IPv4 Add-on Configuration</h4>
          </vs-col>
          
          <vs-col vs-w="12">
            <vs-switch v-model="formData.ipv4_addon_enabled" class="mb-3">
              <span slot="on">IPv4 Add-ons Enabled</span>
              <span slot="off">IPv4 Add-ons Disabled</span>
            </vs-switch>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12" v-if="formData.ipv4_addon_enabled">
            <vs-input
              v-model.number="formData.ipv4_addon_price"
              class="w-full mb-3"
              label="IPv4 Add-on Price (Rials/month)"
              type="number"
              min="0"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="12">
            <vs-switch v-model="formData.is_active" class="mb-3">
              <span slot="on">Active</span>
              <span slot="off">Inactive</span>
            </vs-switch>
          </vs-col>
          
          <vs-col vs-w="12" class="flex justify-end">
            <vs-button
              color="danger"
              type="border"
              @click="showDialog = false"
              class="mr-2"
            >
              Cancel
            </vs-button>
            <vs-button
              color="primary"
              @click="saveRegion()"
            >
              {{ formData.id ? 'Update' : 'Create' }}
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'RegionsList',
  data() {
    return {
      regions: [],
      showDialog: false,
      filters: {
        name: '',
        is_active: ''
      },
      pagination: {
        current_page: 1,
        last_page: 1
      },
      formData: {
        id: null,
        name: '',
        code: '',
        country: '',
        city: '',
        description: '',
        display_order: 0,
        is_active: true,
        ipv4_addon_enabled: false,
        ipv4_addon_price: 50000
      }
    }
  },
  mounted() {
    this.loadRegions()
  },
  methods: {
    async loadRegions() {
      try {
        const params = {
          ...this.filters
        }
        console.log('Loading regions with params:', params)
        const response = await this.$http.get('/admin/haioflash/regions', { params })
        console.log('Regions response:', response.data)
        console.log('Regions data:', response.data.data)
        console.log('Is array:', Array.isArray(response.data.data))
        if (response && response.data && response.data.success) {
          this.regions = Array.isArray(response.data.data) ? response.data.data : []
          console.log('Regions loaded:', this.regions)
        } else {
          this.regions = []
        }
      } catch (error) {
        console.error('Error loading regions:', error)
        console.error('Error response:', error.response)
        this.regions = []
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load regions',
          color: 'danger'
        })
        console.error(error)
      }
    },
    
    editRegion(region) {
      this.formData = { ...region }
      this.showDialog = true
    },
    
    async saveRegion() {
      try {
        if (this.formData.id) {
          await this.$http.put(`/admin/haioflash/regions/${this.formData.id}`, this.formData)
          this.$vs.notify({
            title: 'Success',
            text: 'Region updated successfully',
            color: 'success'
          })
        } else {
          await this.$http.post('/admin/haioflash/regions', this.formData)
          this.$vs.notify({
            title: 'Success',
            text: 'Region created successfully',
            color: 'success'
          })
        }
        this.showDialog = false
        this.resetForm()
        this.loadRegions()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to save region',
          color: 'danger'
        })
        console.error(error)
      }
    },
    
    async toggleRegionStatus(id) {
      try {
        await this.$http.post(`/admin/haioflash/regions/${id}/toggle-active`)
        this.$vs.notify({
          title: 'Success',
          text: 'Region status updated',
          color: 'success'
        })
        this.loadRegions()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to update region status',
          color: 'danger'
        })
      }
    },
    
    async deleteRegion(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this region?',
        accept: async () => {
          try {
            await this.$http.delete(`/admin/haioflash/regions/${id}`)
            this.$vs.notify({
              title: 'Success',
              text: 'Region deleted successfully',
              color: 'success'
            })
            this.loadRegions()
          } catch (error) {
            this.$vs.notify({
              title: 'Error',
              text: 'Failed to delete region',
              color: 'danger'
            })
          }
        }
      })
    },
    
    resetForm() {
      this.formData = {
        id: null,
        name: '',
        code: '',
        country: '',
        city: '',
        description: '',
        display_order: 0,
        is_active: true,
        ipv4_addon_enabled: false,
        ipv4_addon_price: 50000
      }
    }
  }
}
</script>
